export default "__VITE_ASSET__DPyGCmbL__"